import axios from "axios"
import { useState } from "react"

const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif', 'application/pdf']
const MAX_SIZE = 10 * 1024 * 1024 // 10MB

const validateFile = (file: File): { valid: boolean; error?: string } => {
  if (!ALLOWED_TYPES.includes(file.type)) {
    return { valid: false, error: `Niedozwolony typ pliku: ${file.type}` }
  }
  if (file.size > MAX_SIZE) {
    return { valid: false, error: `Plik za duży (max ${MAX_SIZE / 1024 / 1024}MB)` }
  }
  const ext = file.name.split('.').pop()?.toLowerCase()
  const allowedExts = ['jpg', 'jpeg', 'png', 'webp', 'gif', 'pdf']
  if (!ext || !allowedExts.includes(ext)) {
    return { valid: false, error: `Niedozwolone rozszerzenie: .${ext}` }
  }
  return { valid: true }
}

const uploadToS3 = async (signedUrl, file) => {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest()
    xhr.open("PUT", signedUrl, true)
    xhr.upload.addEventListener("progress", function (e) {
      // progress tracking
    })

    xhr.onreadystatechange = function (e) {
      if (xhr.readyState === 4 && xhr.status === 200) {
        resolve({
          url: signedUrl,
        })
      }
    }
    xhr.send(file)
  })
}
export const useFileUpload = () => {
  const [isUploading, setIsUploading] = useState(false)

  const uploadFile = async (req, file) => {
    // Validate file before upload
    const validation = validateFile(file)
    if (!validation.valid) {
      throw new Error(validation.error)
    }

    var url = process.env.REACT_APP_WAKACJE_API_URL + `/v1/getUploadCode`

    var res = await axios.post(url, req)
    if (res.status === 200) {
      const { signedUrl, key, bucket } = res.data
      var uploadResult = await uploadToS3(signedUrl, file)
      return {
        key,
        bucket,
      }
    } else {
      setIsUploading(false)
      throw new Error("Error uploading file")
    }
  }

  return { uploadFile, isUploading }
}
